/* ZFileFunct
Versione 1.0.0 - 20 Settembre 2022 - Mauro Brasile
                 - Prima versione
*/

export class TZFileFunct
{
  static ExtractFileName(Path)
  {
      if(Path.includes("\\"))
      {
        Path = Path.split("\\")
        return Path[Path.length - 1]
      }
      if(Path.includes("/"))
      {
        Path = Path.split('/')
        return Path[Path.length - 1]
      }
      else return
  }
}